import React, { forwardRef } from 'react'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'
import '../../styles/scss/components/equote-agent-details-banner.scss'

const AgentInfoBanner = forwardRef((props, ref) => {
  const {
    agent,
    agency,
    agencyImage,
    goToNextStep,
    currentStep,
    brandClassName,
    goBackToDetails
  } = props

  return (
    <div ref={ref} className="equote-agent-details-banner show">
      <div className="u-content-container">
        <div className="equote-agent-details-banner--inner">
          {agencyImage && (
            <img
              className="equote-agent-details-banner--contacts--logo"
              src={agencyImage}
              alt="travel agency logo"
            />
          )}
          <div className="equote-agent-details-banner--contacts">
            {agent && agent.name && (
              <div className={`item ${brandClassName}`}>
                <p className="item--title u-remove-margin">Agent Name</p>
                <p className="item--info u-remove-margin">{agent.name}</p>
              </div>
            )}

            {agency && agency.name && (
              <div className={`item ${brandClassName}`}>
                <p className="item--title u-remove-margin">Agency</p>
                <p className="item--info u-remove-margin">{agency.name}</p>
              </div>
            )}

            {agent && agent.email && (
              <div className={`item ${brandClassName}`}>
                <p className="item--title u-remove-margin">Email</p>
                <p className="item--info u-remove-margin">{agent.email}</p>
              </div>
            )}

            {agency && agency.phone && (
              <div className={`item ${brandClassName}`}>
                <p className="item--title u-remove-margin">Phone</p>
                <p className="item--info u-remove-margin">{agency.phone}</p>
              </div>
            )}

            {agency && agency.website && (
              <div className={`item ${brandClassName}`}>
                <p className="item--title u-remove-margin">Website</p>
                <p className="item--info u-remove-margin">
                  <a
                    href={
                      agency.website.includes('http://') ||
                      agency.website.includes('https://')
                        ? agency.website
                        : `http://${agency.website}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {agency.website}
                  </a>
                </p>
              </div>
            )}
          </div>
          <div className="equote-agent-details-banner--button">
            <button
              className="btn btn-primary u-uppercase"
              onClick={() => {
                if (!currentStep) {
                  triggerCustomGaEvent('sailingPreview-requestSailing', true)
                  goToNextStep(currentStep)
                } else {
                  triggerCustomGaEvent('sailingPreview-returnToDetails', true)
                  goBackToDetails()
                }
              }}
            >
              {currentStep ? 'Return to Details' : 'Request This Sailing'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
})

export default AgentInfoBanner
